import { BACKEND_BASE_URL } from "@/utils/globalConstants.js";
import { fetchAndLog } from "@/utils/fetchAndLogToBackend.js";
import {getRequest, postRequest} from "@/services/utils";

export const baseUrl = BACKEND_BASE_URL;

export class ClassRoom {
  static getDetailedClassRoomInformation(options) {
    const { classRoomId, candidateId } = options;
    // const authToken = localStorage.getItem("authToken");
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }

    const url = `${baseUrl}/adapt/v1/learning/users/${candidateId}/classrooms/${classRoomId}`;

    const request = getRequest();

    return fetchAndLog(url, request);
  }

  static getStudentPanel(options) {
    const { classRoomId, candidateId, cpId, rootId } = options;
    // const authToken = localStorage.getItem("authToken");
    // if (!authToken) {
    //   window.clientLogger("No auth token found");
    //   throw new Error("No auth token found");
    // }

    const url = `${baseUrl}/adapt/v1/learning/users/${candidateId}/classrooms/${classRoomId}/packages/${cpId}/node/${rootId}/studentpanel`;

    const request = getRequest();

    return fetchAndLog(url, request);
  }

  static stopTest(options) {
    const { classRoomId, candidateId, rootId, payload } = options;

    const url = `${baseUrl}/adapt/v1/learning/users/${candidateId}/classrooms/${classRoomId}/chaincontexts/${rootId}/statements`;

    const request = postRequest(payload);

    return fetchAndLog(url, request);
  }

  static getStudentPanelMetaData(options) {
    const { classRoomId, candidateId, cpId, tocRoot } = options;

    const url = `${baseUrl}/adapt/v1/learning/users/${candidateId}/classrooms/${classRoomId}/packages/${cpId}/node/${tocRoot}/studentpanel`;

    const request = getRequest();

    return fetchAndLog(url, request);
  }

  static startTestTutomat(options) {
    const { classRoomId, candidateId, chainContextId, payload } = options;

    const url = `${baseUrl}/adapt/v1/learning/users/${candidateId}/classrooms/${classRoomId}/chaincontexts/${chainContextId}/statements`;

    const request = postRequest(payload);
    
    return fetchAndLog(url, request);
  }

  static getExampleTest() {
    const url = `${baseUrl}/kartlegging/exampletest`;

    const request = getRequest();

    return fetchAndLog(url, request);
  }
}